import PropTypes from "prop-types";
import { jsx as _jsx } from "react/jsx-runtime";
const ConditionalWrapper = _ref => {
  let {
    condition,
    wrapper,
    children
  } = _ref;
  if (condition) {
    const Wrapper = wrapper.type;
    return /*#__PURE__*/_jsx(Wrapper, {
      ...wrapper.props,
      children: children
    });
  }
  return children;
};
ConditionalWrapper.propTypes = {
  /** A condition if met, will render the wrapper around the children */
  condition: function (props, propName, componentName) {
    try {
      !!props[propName];
    } catch (error) {
      return new Error(`Invalid prop \`${propName}\` supplied to \`${componentName}\`. Please pass in an expression.`);
    }
  },
  /** An instance of a React element that is used to conditionally wrap the children */
  wrapper: PropTypes.node.isRequired,
  /** The children that will be conditionally wrapped */
  children: PropTypes.node
};
export default ConditionalWrapper;